const CustomizeColumnIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.375 8.5H21.625C22.6591 8.5 23.5 9.34094 23.5 10.375V21.625C23.5 22.6591 22.6591 23.5 21.625 23.5H10.375C9.34094 23.5 8.5 22.6591 8.5 21.625V10.375C8.5 9.34094 9.34094 8.5 10.375 8.5ZM17.875 22.25V14.125V9.75H14.125V14.125V22.25H17.875ZM19.125 22.25H21.625C21.9697 22.25 22.25 21.9697 22.25 21.625V14.125V12.875V10.375C22.25 10.0303 21.9697 9.75 21.625 9.75H19.125V14.125V22.25ZM9.75 12.875V10.375C9.75 10.0303 10.0303 9.75 10.375 9.75H12.875V14.125V22.25H10.375C10.0303 22.25 9.75 21.9697 9.75 21.625V14.125V12.875Z"
        fill="#8C9EB8"
      />
      <rect x="0.5" y="0.5" width="31" height="31" rx="5.5" stroke="#8C9EB8" />
    </svg>
  );
};

export default CustomizeColumnIcon;
